import React, { createContext, useContext, useMemo, useState } from "react";
import { api, apiJson, getToken, setToken } from "@/api/client.js";

const AuthContext = createContext(null);
const AUTH_KEY = "orignal2026.auth";

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
    } catch {
      return null;
    }
  });

  const value = useMemo(() => {
    const isAuthenticated = Boolean(session && getToken());
    return {
      isAuthenticated,
      user: session,
      username: session?.username,
      role: session?.role,
      name: session?.member?.display_name || session?.username,
      login: async (username, password) => {
        const data = await apiJson("/api/auth/login", { username, password });
        setToken(data.token);
        localStorage.setItem(AUTH_KEY, JSON.stringify(data.user));
        setSession(data.user);
        return data.user;
      },
      logout: () => {
        api("/api/auth/logout", { method: "POST" }).catch(() => {});
        setToken("");
        localStorage.removeItem(AUTH_KEY);
        setSession(null);
      },
      refreshMe: async () => {
        const me = await api("/api/me");
        localStorage.setItem(AUTH_KEY, JSON.stringify(me));
        setSession(me);
        return me;
      },
    };
  }, [session]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth requires AuthProvider");
  return ctx;
}
